<div class="course-timing-modal-wrapper">
    <div class="course-timing-modal-body">
        <div class="column course-details-column">
            <div class="course-img-wrapper" *ngIf="courseTypeImg; else shimmerEffect"
                [ngStyle]="{'background': 'linear-gradient(to bottom, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 1) 210px, rgba(255, 255, 255, 1) 290px), url(' + courseTypeImg + ') no-repeat center/cover'}">
                <div class="previous-btn" (click)="goToPrevModal()">
                    <img src="../../../../../../assets/icons/chevron-right.svg" alt="">Retour
                </div>
            </div>

            <ng-template #shimmerEffect>
                <div class="course-img-wrapper shimmer">
                    <div class="previous-btn" (click)="goToPrevModal()">
                        <img src="../../../../../../assets/icons/chevron-right.svg" alt="">Retour
                    </div>
                </div>
            </ng-template>

            <div class="course-details-wrapper">
                <div class="course-name"><span class="course-name-text">{{selectedCourse?.name}}</span></div>
                <div class="instructor"> <img src="../../../../../../assets/icons/courseInstructor.svg" alt="Instructor"
                        class="instructor-img"> <span class="instructor-text">{{courseData.instructor}}</span> </div>
                <div class="location"><img src="../../../../../../assets/icons/courseLocation.svg" alt="Location"
                        class="location-img"><span class="location-text">{{courseData.location}}</span></div>
            </div>
        </div>
        <div class="column course-timing-column">
            <div class="course-timing-column-header">
                <div class="course-timing-title-close-btn">
                    <span class="course-timing-title">Date de cours</span>
                    <div class="close-course-timing-modal-btn" (click)="closeCourseCreation()"><img
                            src="../../../../../../assets/icons/x-close.svg" alt=""></div>
                </div>
                <span class="course-timing-description">Choisissez la date, l’heure pour planifier votre cours</span>
            </div>
            <div class="course-timing-subcolumn-wrapper">
                <div class="sub-column course-date-sub-column">
                    <mat-calendar #calendar [dateClass]="dateClass" [headerComponent]="CustomCalendarHeader"
                        [selected]="null" [startAt]="monthStartAt"  (selectedChange)="onDateSelected($event,calendar)"></mat-calendar>
                </div>
                <div class="sub-column course-time-sub-column">
                    <span class="course-time-sub-column-header">Heure du cours</span>
                    <app-webiat-timepicker [label]="'Heure de début'" class="course-time-sub-column-start "
                        placeholder="hh:mm" [maxTime]="courseTimingForm.get('endTime')?.value || null"
                        [control]="castFormControl('startTime')">
                    </app-webiat-timepicker>
                    <app-webiat-timepicker [label]="'Heure de fin'" placeholder="hh:mm"
                        [minTime]="courseTimingForm.get('startTime')?.value || null" class="course-time-sub-column-end "
                        [control]="castFormControl('endTime')">
                    </app-webiat-timepicker>
                </div>
            </div>
        </div>
    </div>
    <div class="course-timing-modal-footer">
        <button class="submit-btn" [disabled]="!courseTimingForm.valid || loading" (click)="updateData()">
            {{data.courseId? 'Modifier le cours':'Publier le cours'}}
        </button>
    </div>
</div>